import PropTypes from 'prop-types';
import React, { useContext } from 'react';
// material
import { Box } from '@mui/material';
// contexts
import { SettingsContext } from '../contexts/Settings';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  const { logo } = useContext(SettingsContext);

  return <Box component="img" src={logo.regular.url} sx={{ width: 130, height: 'auto', ...sx }} />;
}
